module.exports = __webpack_public_path__ + "static/media/blog4.18208d8f.jpg";